import { useMutation, useQuery } from "react-query";
import { OrganizationAdministration } from "../../api";
import { useAuth } from "../../context";

export const organizationAdministrationKeys = {
  user: () => ["user"],
  division: () => ["division"],
  allSuppliers: () => ["allSuppliers"],
  emissionFactorMapping: () => ["emissionFactorMapping"],
  scopeTwoConfig: () => ["scopeTwoConfig"],
  financialYear: () => ["financialYear"],
};

export function useGetAllSuppliers(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.allSuppliers(),
    () => callApi(OrganizationAdministration.getAllSuppliers), config);
}

export function useGetSupplierUsers(supplierId, config) {
  const { callApi } = useAuth();
  return useQuery([supplierId],
    () => callApi(OrganizationAdministration.getSupplierUsers, supplierId), config);
}

export function useGetOrganizationUsers(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.user(),
    () => callApi(OrganizationAdministration.getOrganizationUsers), config);
}

export function useGetEmissionFactorMapping(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.emissionFactorMapping(),
    () => callApi(OrganizationAdministration.getEmissionFactorMapping), config);
}

export function useUpdateEmissionFactorMapping(config) {
  const { callApi } = useAuth();
  return useMutation(
    (mapping) => callApi(OrganizationAdministration.updateEmissionFactorMapping, mapping),
    config
  );
}

export function useGetScopeTwoConfig(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.scopeTwoConfig(),
    () => callApi(OrganizationAdministration.getScopeTwoConfig), config);
}

export function useUpdateScopeTwoConfig(config) {
  const { callApi } = useAuth();
  return useMutation(
    (scopeTwoConfig) => callApi(OrganizationAdministration.updateScopeTwoConfig, scopeTwoConfig),
    config
  );
}

export function useGetFinancialYear(config) {
  const { callApi } = useAuth();
  return useQuery(organizationAdministrationKeys.financialYear(),
    () => callApi(OrganizationAdministration.getFinancialYear), config);
}

export function useUpdateFinancialYear(config) {
  const { callApi } = useAuth();
  return useMutation(
    (financialYear) => callApi(OrganizationAdministration.updateFinancialYear, financialYear),
    config
  );
}
